import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";

import { mod } from "@shared/utils";

import { Body } from "../typography";

import s from "./message-wrapper.module.scss";

export type MessageWrapperProps = ComponentProps<"div"> & {
  className?: string;
  variant: "left-bottom" | "right-bottom";
  children: ReactNode;
};

export const MessageWrapper = (props: MessageWrapperProps) => {
  const { className, variant, children } = props;

  const mods = mod(s, { variant });

  return (
    <Body tag="div" weight="semiBold" className={clsx(s.root, className, mods)}>
      <div>{children}</div>
    </Body>
  );
};

MessageWrapper.displayName = "MessageWrapper";
